/**
 * @module FE-CU39_新規サブユーザー登録画面_仮登録
 */
import Header from '../../components/header/Header.vue';
import ListPanel from '../../components/listPanel/ListPanel.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../constants';
import { checkMailAddressFormat } from '../../utile/validation';

const PAGE_ID = 'FE-CU39';

export default {
  name: 'SubUserTempRegistration',
  components: {
    Header,
    BreadCrumbList,
    ListPanel,
    PcPageTitle,
    MobileFooter,
    PCFooter,
  },
  data(vm) {
    return {
      valid: true,
      title: vm.$vuetify.lang.t(
        '$vuetify.FECU39新規サブユーザー登録画面仮登録.新規サブユーザー登録仮登録'
      ),
      hintText: vm.$vuetify.lang.t(
        '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.C0001'
      ),
      marginBottom: 30,
      displayAreaTitle: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      displayAreaList: [],
      excludeFromDisplayArea: {
        id: 1,
        label: '対象地区から除外する',
        isExclude: true,
      },
      subUserDialog: false,
      subUserDisplayAreas: [],
      subUser: {
        email: '',
        confirmEmail: '',
      },
      error: {
        hasEmailError: false,
        hasConfirmEmailError: false,
      },
      authorityList: [
        {
          id: 1,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.警備操作',
          isChecked: false,
        },
        {
          id: 2,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.かけつけ依頼',
          isChecked: false,
        },
        {
          id: 3,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.通知通知履歴',
          isChecked: false,
        },
        {
          id: 4,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.機器制御',
          isChecked: false,
        },
        {
          id: 5,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ALSOKへのお問い合わせ',
          isChecked: false,
        },
        {
          id: 6,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ニックネーム設定対象地区',
          isChecked: false,
        },
        {
          id: 7,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.IDカードキー情報設定',
          isChecked: false,
        },
        {
          id: 8,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.見守り情報配信設定',
          isChecked: false,
        },
        {
          id: 9,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.戸締り確認警報確認',
          isChecked: false,
        },
        {
          id: 10,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.在宅対象設定',
          isChecked: false,
        },
        {
          id: 11,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ユーザー管理',
          isChecked: false,
        },
        {
          id: 12,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.緊急連絡先',
          isChecked: false,
        },
      ],
      authorityListCamera: [
        {
          id: 1,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.カメラ映像',
          isChecked: false,
        },
        {
          id: 2,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.かけつけ依頼',
          isChecked: false,
        },
        {
          id: 3,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.通知通知履歴',
          isChecked: false,
        },
        {
          id: 4,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ALSOKへのお問い合わせ',
          isChecked: false,
        },
        {
          id: 5,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ニックネーム設定カメラ',
          isChecked: false,
        },
        {
          id: 6,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ユーザー管理',
          isChecked: false,
        },
        {
          id: 7,
          label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.緊急連絡先',
          isChecked: false,
        },
      ],
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    emailRules() {
      // require
      if (this.subUser.email === '') {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.E0005'
          ),
        ];
      }
      // validation
      if (typeof this.subUser.email === 'undefined') {
        return [true];
      } else {
        return [
          checkMailAddressFormat(this.subUser.email) ||
            this.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.E0003'
            ),
        ];
      }
    },
    confirmRules() {
      // require
      if (this.subUser.confirmEmail === '') {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.E0006'
          ),
        ];
      }
      // confirmation
      if (this.subUser.confirmEmail !== this.subUser.email) {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.E0007'
          ),
        ];
      }
      // メールアドレスと確認用メールアドレスの同一チェック
      if (this.subUser.email !== this.subUser.confirmEmail) {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.E0007'
          ),
        ];
      }
      // validation
      if (typeof this.subUser.confirmEmail === 'undefined') {
        return [true];
      } else {
        return [
          checkMailAddressFormat(this.subUser.confirmEmail) ||
            this.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.E0004'
            ),
        ];
      }
    },
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t(
          '$vuetify.FECU39新規サブユーザー登録画面仮登録.新規サブユーザー登録仮登録'
        ),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.C0001'
        ),
        displayAreaTitle: {
          place: '',
          type: '',
          typeIsBefore: true,
        },
        authorityList: [
          {
            id: 1,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.警備操作',
            isChecked: this.authorityList[0].isChecked,
          },
          {
            id: 2,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.かけつけ依頼',
            isChecked: this.authorityList[1].isChecked,
          },
          {
            id: 3,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.通知通知履歴',
            isChecked: this.authorityList[2].isChecked,
          },
          {
            id: 4,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.機器制御',
            isChecked: this.authorityList[3].isChecked,
          },
          {
            id: 5,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ALSOKへのお問い合わせ',
            isChecked: this.authorityList[4].isChecked,
          },
          {
            id: 6,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ニックネーム設定対象地区',
            isChecked: this.authorityList[5].isChecked,
          },
          {
            id: 7,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.IDカードキー情報設定',
            isChecked: this.authorityList[6].isChecked,
          },
          {
            id: 8,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.見守り情報配信設定',
            isChecked: this.authorityList[7].isChecked,
          },
          {
            id: 9,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.戸締り確認警報確認',
            isChecked: this.authorityList[8].isChecked,
          },
          {
            id: 10,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.在宅対象設定',
            isChecked: this.authorityList[9].isChecked,
          },
          {
            id: 11,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ユーザー管理',
            isChecked: this.authorityList[10].isChecked,
          },
          {
            id: 12,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.緊急連絡先',
            isChecked: this.authorityList[11].isChecked,
          },
        ],
        authorityListCamera: [
          {
            id: 1,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.カメラ映像',
            isChecked: this.authorityListCamera[0].isChecked,
          },
          {
            id: 2,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.かけつけ依頼',
            isChecked: this.authorityListCamera[1].isChecked,
          },
          {
            id: 3,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.通知通知履歴',
            isChecked: this.authorityListCamera[2].isChecked,
          },
          {
            id: 4,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ALSOKへのお問い合わせ',
            isChecked: this.authorityListCamera[3].isChecked,
          },
          {
            id: 5,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ニックネーム設定カメラ',
            isChecked: this.authorityListCamera[4].isChecked,
          },
          {
            id: 6,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ユーザー管理',
            isChecked: this.authorityListCamera[5].isChecked,
          },
          {
            id: 7,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.緊急連絡先',
            isChecked: this.authorityListCamera[6].isChecked,
          },
        ],
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * エラーありの場合、動的にclassを設定
     * @param {boolean} hasError エラーありなし
     * @returns {object} class
     */
    appendAlertClass(hasError) {
      return { alert: hasError };
    },
    /**
     * おすすめボタン押下処理
     */
    recommendButton() {
      if (this.$store.state.currentDisplayType === 1) {
        const recommend = JSON.parse(process.env.VUE_APP_RECOMMEND_SECURITY_UNIT_AUTHORITY_SETTING);
        this.authorityList = [
          {
            id: 1,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.警備操作',
            isChecked: recommend.securityOperation,
          },
          {
            id: 2,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.かけつけ依頼',
            isChecked: recommend.rushOrder,
          },
          {
            id: 3,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.通知通知履歴',
            isChecked: recommend.notificationHistory,
          },
          {
            id: 4,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.機器制御',
            isChecked: recommend.deviceControl,
          },
          {
            id: 5,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ALSOKへのお問い合わせ',
            isChecked: recommend.contact,
          },
          {
            id: 6,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ニックネーム設定対象地区',
            isChecked: recommend.nicknameSetting,
          },
          {
            id: 7,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.IDカードキー情報設定',
            isChecked: recommend.IDCardKeyInfoSetting,
          },
          {
            id: 8,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.見守り情報配信設定',
            isChecked: recommend.watchOverInfoDeliverySetting,
          },
          {
            id: 9,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.戸締り確認警報確認',
            isChecked: recommend.lockUpCheck,
          },
          {
            id: 10,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.在宅対象設定',
            isChecked: recommend.targetAtHomeSetting,
          },
          {
            id: 11,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ユーザー管理',
            isChecked: recommend.userManagement,
          },
          {
            id: 12,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.緊急連絡先',
            isChecked: recommend.emergencyContact,
          },
        ];
      } else if (this.$store.state.currentDisplayType === 2) {
        const recommend_camera = JSON.parse(process.env.VUE_APP_RECOMMEND_CAMERA_AUTHORITY_SETTING);
        this.authorityListCamera = [
          {
            id: 1,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.カメラ映像',
            isChecked: recommend_camera.anticrimeCameraVideos,
          },
          {
            id: 2,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.かけつけ依頼',
            isChecked: recommend_camera.rushOrder,
          },
          {
            id: 3,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.通知通知履歴',
            isChecked: recommend_camera.notificationHistory,
          },
          {
            id: 4,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ALSOKへのお問い合わせ',
            isChecked: recommend_camera.contact,
          },
          {
            id: 5,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ニックネーム設定カメラ',
            isChecked: recommend_camera.nicknameSetting,
          },
          {
            id: 6,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.ユーザー管理',
            isChecked: recommend_camera.userManagement,
          },
          {
            id: 7,
            label: '$vuetify.FECU39新規サブユーザー登録画面仮登録.緊急連絡先',
            isChecked: recommend_camera.emergencyContact,
          },
        ];
      }
    },
    /**
     * お知らせダイアログ
     */
    async callSaveMessageDialog() {
      await this.$informationDialog(
        '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.C0005'
      );

      // FE-CU37_ユーザー管理画面に遷移
      this.$router.push('userManagement');
    },
    /**
     * 確認ダイアログ
     * @description 「はい」押下後、仮登録処理を実行
     */
    async callSaveAgreementDialogDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.C0002',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result === true) {
        let apiResult = null;

        let param =
          this.$store.state.currentDisplayType === 1
            ? '/api/subUserTempRegistration/tempRegistrationDisplayDistrict'
            : '/api/subUserTempRegistration/tempRegistrationCamera';
        // let param = "post";

        let method = 'post';

        // メールをセット
        const mail = this.subUser.email;

        // 1: 対象地区, 2: カメラ
        if (this.$store.state.currentDisplayType === 1) {
          // 対象地区のチェック入力をセット
          const subUserAuthority = {
            securityOperation: this.authorityList[0].isChecked,
            rushOrder: this.authorityList[1].isChecked,
            notificationHistory: this.authorityList[2].isChecked,
            deviceContorol: this.authorityList[3].isChecked,
            contact: this.authorityList[4].isChecked,
            nicknameSetting: this.authorityList[5].isChecked,
            IDCardKeyInfoSetting: this.authorityList[6].isChecked,
            watchOverInfoDeliverySetting: this.authorityList[7].isChecked,
            lockUpCheck: this.authorityList[8].isChecked,
            targetAtHomeSetting: this.authorityList[9].isChecked,
            userManagement: this.authorityList[10].isChecked,
            emergencyContact: this.authorityList[11].isChecked,
          };
          const queries = {
            token: sessionStorage.getItem('token'),
            terminalInfo: localStorage.getItem('terminalInfo')
              ? localStorage.getItem('terminalInfo')
              : '',
            customerNumber: this.$store.state.customerNumber,
            districtSplitNumber: this.$store.state.districtSplitNumber,
            mail: mail,
            subUserAuthority: subUserAuthority,
          };
          // APIコール
          apiResult = await this.APP_CU3903(param, queries, method);

          if (apiResult && apiResult == 2) {
            this.$errorDialog(
              this.$vuetify.lang.t(
                '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.E0001'
              )
            );
          }
        } else if (this.$store.state.currentDisplayType == 2) {
          // カメラのチェック入力をセット
          const subUserAuthority = {
            anticrimeCameraVideos: this.authorityListCamera[0].isChecked,
            rushOrder: this.authorityListCamera[1].isChecked,
            notificationHistory: this.authorityListCamera[2].isChecked,
            contact: this.authorityListCamera[3].isChecked,
            nicknameSetting: this.authorityListCamera[4].isChecked,
            userManagement: this.authorityListCamera[5].isChecked,
            emergencyContact: this.authorityListCamera[6].isChecked,
          };
          const queries = {
            token: sessionStorage.getItem('token'),
            terminalInfo: localStorage.getItem('terminalInfo')
              ? localStorage.getItem('terminalInfo')
              : '',
            deviceID: this.$store.state.deviceID,
            mail: mail,
            subUserAuthority: subUserAuthority,
          };
          // APIコール
          apiResult = await this.APP_CU3904(param, queries, method);
          if (apiResult && apiResult == 2) {
            this.$errorDialog(
              this.$vuetify.lang.t(
                '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.E0001'
              )
            );
          }
        }

        // OK API成功時
        if (apiResult && apiResult == 1) {
          this.callSaveMessageDialog();
        }
      } else {
        // キャンセル
      }
    },
    /**
     * 権限リストの更新
     * @param {number} id authorityListに割り振ったid
     */
    toggleCheckbox(id) {
      if (this.$store.state.currentDisplayType == 1) {
        this.authorityList.map((authority) => {
          if (id == authority.id) {
            authority.isChecked = !authority.isChecked;
          }
        });
      } else if (this.$store.state.currentDisplayType == 2) {
        this.authorityListCamera.map((authority) => {
          if (id == authority.id) {
            authority.isChecked = !authority.isChecked;
          }
        });
      }
    },
    /**
     * APP_CU3901 初期表示(表示地区)
     * @param {string} param エンドポイント
     * @param {object} queries リクエスト
     * @param {string} method HTTPメソッド
     * @returns {object} レスポンス
     */
    APP_CU3901: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      let hasError = false;
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ(対象地区)
            // apiData = {
            //   contentsInfo: {
            //     // 対象地区情報
            //     displayDistrictInfo: {
            //       usagePlan: 0, // 0: オンライン監視プラン 1: 依頼かけつけプラン 2:セルフ監視プラン
            //       customerNumber: "51-1234567", // お客様番号
            //       securityDestinationName: "警備先1", // 警備先名
            //       districtSplitNumber: "0001", // 地区番号
            //       districtSplitName: "地区名1234", // 地区名
            //       displayDistrictNickname: "自宅", // ニックネーム(対象地区)
            //     },
            //   },
            // };
          },
          (error) => {
            hasError = true;
            this.$_abnormality(error.response.status);
            return;
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      if (hasError) return;

      // ListPanel用にデータを整形
      const targetItem = apiData.contentsInfo.displayDistrictInfo;

      // データ整形
      const labels = {
        usagePlan: '$vuetify.FECU39新規サブユーザー登録画面仮登録.対象地区詳細表示領域.利用プラン',
        customerNumber:
          '$vuetify.FECU39新規サブユーザー登録画面仮登録.対象地区詳細表示領域.お客様番号',
        securityDestinationName:
          '$vuetify.FECU39新規サブユーザー登録画面仮登録.対象地区詳細表示領域.警備先名',
        districtSplitNumber:
          '$vuetify.FECU39新規サブユーザー登録画面仮登録.対象地区詳細表示領域.地区番号',
        districtSplitName:
          '$vuetify.FECU39新規サブユーザー登録画面仮登録.対象地区詳細表示領域.地区名',
        displayDistrictNickname:
          '$vuetify.FECU39新規サブユーザー登録画面仮登録.対象地区詳細表示領域.ニックネーム対象地区',
      };
      const targetKeys = [
        'usagePlan',
        'customerNumber',
        'securityDestinationName',
        'districtSplitNumber',
        'districtSplitName',
        'displayDistrictNickname',
      ];
      const planTitles = {
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.オンライン監視プラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
          '$vuetify.コード.利用プランID.依頼かけつけプラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
          '$vuetify.コード.利用プランID.依頼かけつけプラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.セルフ監視プラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
          '$vuetify.コード.利用プランID.セルフ監視プラン',
      };
      // ListPanelコンポーネント用に整形
      Object.keys(targetItem).map((key, index) => {
        if (targetKeys.includes(key)) {
          let text = targetItem[key];
          if (key === 'usagePlan') {
            text = planTitles[targetItem[key]];
          }
          if (key === 'districtSplitNumber') {
            if (targetItem[key] === '    ') {
              text = '$vuetify.FECU39新規サブユーザー登録画面仮登録.メイン地区';
            }
            if (targetItem[key] === '') {
              return;
            }
          }
          this.displayAreaList = [
            ...this.displayAreaList,
            {
              id: index,
              title: labels[key],
              text: text,
            },
          ];
        }
      });
      // 対象地区ニックネームを設定
      this.displayAreaTitle = {
        place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname}`,
        type: '$vuetify.FECU39新規サブユーザー登録画面仮登録.対象地区詳細表示領域.対象地区',
        typeIsBefore: true,
      };

      return apiData;
    },
    /**
     * APP_CU3902 初期表示(カメラ)
     * @param {string} param エンドポイント
     * @param {object} queries リクエスト
     * @param {string} method HTTPメソッド
     * @returns {object} レスポンス
     */
    APP_CU3902: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      let hasError = false;
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ(カメラ)
            // apiData = {
            //   contentsInfo: {
            //     // カメラ情報
            //     cameraInfo: {
            //       usagePlan: 0, // 0: オンライン監視プラン 1: 依頼かけつけプラン 2:セルフ監視プラン
            //       customerNumber: "51-1234567", // お客様番号
            //       securityDestinationName: "警備先1", // 警備先名
            //       districtSplitNumber: "0001", // 地区番号
            //       districtSplitName: "地区名1234", // 地区名
            //       displayDistrictNickname: "自宅", // ニックネーム(対象地区)
            //       cameraNickName: "自宅カメラ", // ニックネーム(カメラ)
            //       deviceID: "12345", // デバイスID
            //     },
            //   },
            // };
          },
          (error) => {
            hasError = true;
            this.$_abnormality(error.response.status);
            return;
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      if (hasError) return;

      // ListPanel用にデータを整形
      const targetItem = apiData.contentsInfo.cameraInfo;

      // データ整形
      const labels = {
        usagePlan: '$vuetify.FECU39新規サブユーザー登録画面仮登録.カメラ詳細表示領域.利用プラン',
        customerNumber:
          '$vuetify.FECU39新規サブユーザー登録画面仮登録.カメラ詳細表示領域.お客様番号',
        securityDestinationName:
          '$vuetify.FECU39新規サブユーザー登録画面仮登録.カメラ詳細表示領域.警備先名',
        districtSplitNumber:
          '$vuetify.FECU39新規サブユーザー登録画面仮登録.カメラ詳細表示領域.地区番号',
        districtSplitName:
          '$vuetify.FECU39新規サブユーザー登録画面仮登録.カメラ詳細表示領域.地区名',
        displayDistrictNickname:
          '$vuetify.FECU39新規サブユーザー登録画面仮登録.カメラ詳細表示領域.ニックネーム対象地区',
      };
      const targetKeys = [
        'usagePlan',
        'customerNumber',
        'securityDestinationName',
        'districtSplitNumber',
        'districtSplitName',
        'displayDistrictNickname',
      ];
      const planTitles = {
        [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.オンライン監視プラン',
        [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
          '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
        [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
      };
      // ListPanelコンポーネント用に整形
      Object.keys(targetItem).map((key, index) => {
        if (targetKeys.includes(key)) {
          let text = targetItem[key];
          if (key === 'usagePlan') {
            text = planTitles[targetItem[key]];
          }
          if (key === 'districtSplitNumber') {
            if (targetItem[key] === '    ') {
              text = '$vuetify.FECU39新規サブユーザー登録画面仮登録.メイン地区';
            }
            if (targetItem[key] === '') {
              return;
            }
          }
          this.displayAreaList = [
            ...this.displayAreaList,
            {
              id: index,
              title: labels[key],
              text: text,
            },
          ];
        }
      });

      // カメラニックネームを設定
      this.displayAreaTitle = {
        place: `- ${apiData.contentsInfo.cameraInfo.cameraNickName}`,
        type: '$vuetify.FECU39新規サブユーザー登録画面仮登録.カメラ詳細表示領域.カメラ',
        typeIsBefore: true,
      };

      return apiData;
    },
    /**
     * APP_CU3903 サブユーザー仮登録(表示地区)
     * @param {string} param エンドポイント
     * @param {object} queries リクエスト
     * @param {string} method HTTPメソッド
     * @returns {object} レスポンス
     */
    APP_CU3903: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ(カメラ)
            // apiData = {
            //   contentsInfo: {
            //     result: 1, // 1:完了 2:メールアドレスが既に該当する対象地区に登録済み 3:該当契約先なし
            //   },
            // };

            return apiData.contentsInfo.result;
          },
          (error) => {
            if (error.message.includes('400')) {
              this.$errorDialog(
                this.$vuetify.lang.t(
                  '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.E0002'
                )
              );
            } else {
              this.$_abnormality(error.response.status);
            }
            return null;
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData.contentsInfo.result;
    },
    /**
     * APP_CU3904 サブユーザー仮登録(カメラ)
     * @param {string} param エンドポイント
     * @param {object} queries リクエスト
     * @param {string} method HTTPメソッド
     * @returns {object} レスポンス
     */
    APP_CU3904: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ(カメラ)
            // apiData = {
            //   contentsInfo: {
            //     result: 1, // 1:完了 2:メールアドレスが既に該当する対象地区に登録済み 3:該当契約先なし 4:デバイスID誤り 5: メールアドレスが本登録済み
            //   },
            // };

            return apiData;
          },
          (error) => {
            if (error.message.includes('400')) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU39新規サブユーザー登録画面仮登録.E0002'
              );
            } else {
              this.$_abnormality(error.response.status);
            }
            return null;
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData.contentsInfo.result;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //ローディングマーク表示と合わせて色々再見直ししたほうが良いかも
    this.isShowPage = true;

    let param =
      this.$store.state.currentDisplayType == 1
        ? '/api/subUserTempRegistration/initDisplayDistrict'
        : '/api/subUserTempRegistration/initCamera';

    let method = 'post';

    // 1: 対象地区, 2: カメラ
    if (this.$store.state.currentDisplayType == 1) {
      // 対象地区の場合
      const queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
      };
      await this.APP_CU3901(param, queries, method);
    } else if (this.$store.state.currentDisplayType == 2) {
      // カメラの場合
      const queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
      };
      await this.APP_CU3902(param, queries, method);
    }
  },
};
